module.exports = __webpack_public_path__ + "files/qr.14d03ee7e7f0eb8de1443539fc903f8a.png";